<template>
  <div>
    <a-card style="border: none; border-radius: 12px; margin-bottom: 20px">
      <a-form layout="inline">
        <a-form-item label="单位名称">
          <a-input v-model="dataForm.name" placeholder="请输入单位名称">
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button @click="getDataList" type="primary"> 搜索 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="dataForm.name = ''"> 重置 </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card style="border: none; border-radius: 12px" title="分包单位">
      <div slot="extra">
        <a-button
          icon="redo"
          @click="query"
          style="background: #edf5ff; border: none; color: #0073ff"
        >
          刷新数据
        </a-button>
        <a-button
          icon="edit"
          @click="batchUpload"
          style="background: #fff9f0; border: none; color: #ef9f22"
          v-permission="['person:company:add']"
        >
          一键导入
        </a-button>
        <a-button
          @click="addOrUpdateHandle()"
          icon="plus"
          style="background: #fff9f0; border: none; color: #ef9f22"
          v-permission="['person:company:add']"
        >
          新建分包单位
        </a-button>
      </div>
      <a-table
        filterMultiple
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
        :scroll="{ x: 1500 }"
        rowKey="id"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onSelect: onSelect,
          onChange: onSelectChange,
          onSelectAll: onSelectAll,
        }"
      >
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button
              size="small"
              type="link"
              @click="addOrUpdateHandle(record.id)"
              v-permission="['person:company:edit']"
              >编辑
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="deleteHandle(record.id)"
              v-permission="['person:company:delete']"
              >删除</a-button
            >
          </a-space>
        </span>
        <span slot="create_time" slot-scope="text">
          {{ moment(text).format("YYYY-MM-DD") }}
        </span>
      </a-table>
      <div style="margin-top: 20px; float: left">
        <a-button
          @click="exportHandle()"
          icon="download"
          style="background: #edf5ff; border: none; color: #0073ff"
        >
          导出
        </a-button>
      </div>
      <a-pagination
        style="margin-top: 20px; float: right"
        show-size-changer
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
        :show-total="(total) => `共 ${total} 条`"
      />
    </a-card>
    <addOrUpdate ref="addOrUpdate" @ok="getDataList"></addOrUpdate>
    <batchUploadCompany
      ref="batchUploadCompany"
      @ok="getDataList"
    ></batchUploadCompany>
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addOrUpdate from "./components/companyaddorupdate.vue";
import batchUploadCompany from "./components/batchUploadCompany.vue";
import { companyFile } from "@/utils/exportFile";
import moment from "moment";
export default {
  mixins: [viewModule],
  components: { addOrUpdate, batchUploadCompany },
  data() {
    return {
      columns: [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 80,
          align: "center",
          customRender: (text, record, index) => {
            return (this.page - 1) * this.limit + index + 1;
          },
        },
        {
          title: "单位名称",
          dataIndex: "name",
          key: "name",
          align: "center",
          width: 200,
        },
        {
          title: "统一社会信用代码",
          align: "center",
          key: "code",
          dataIndex: "code",
          width: 250,
        },
        {
          title: "法人",
          align: "center",
          key: "legal_person",
          dataIndex: "legal_person",
          width: 100,
        },
        {
          title: "注册资本/万元",
          align: "center",
          key: "registered_capital",
          dataIndex: "registered_capital",
          width: 200,
          // customRender: (text) => `${text}万元`,
        },
        {
          title: "成立日期",
          align: "center",
          key: "establish",
          dataIndex: "establish",
          width: 120,
        },
        {
          title: "营业期限/年",
          align: "center",
          key: "business_term",
          dataIndex: "business_term",
          width: 120,
          // customRender: (text) => `${text}年`,
        },
        {
          title: "联系人姓名",
          align: "center",
          key: "contacts",
          dataIndex: "contacts",
          width: 120,
        },
        {
          title: "联系电话",
          align: "center",
          key: "telephone",
          dataIndex: "telephone",
          width: 150,
        },
        {
          title: "单位地址",
          align: "center",
          key: "address",
          dataIndex: "address",
          width: 200,
        },
        // {
        //   title: "创建时间",
        //   align: "center",
        //   key: "create_time",
        //   dataIndex: "create_time",
        //   scopedSlots: { customRender: "create_time" },
        // },
        {
          title: "操作",
          key: "action",
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      mixinViewModuleOptions: {
        getDataListURL: "/company/page",
        deleteURL: "/company/delete",
      },
      dataForm: { name: "" },
      exportFileKey: companyFile,
      exportFileName: "分包单位导出文件",
    };
  },
  methods: {
    moment,
    //批量上传
    batchUpload() {
      this.$refs.batchUploadCompany.init();
    },
    // onSelectChange(selectedRowKeys, selectedRows) {
    //   this.selectedRowKeys = selectedRowKeys;
    //   this.dataListSelections = selectedRows;
    // },
  },
};
</script>

<style></style>